import { render, staticRenderFns } from "./platform_user_detail.vue?vue&type=template&id=0c2b1a04&scoped=true&"
import script from "./platform_user_detail.vue?vue&type=script&lang=js&"
export * from "./platform_user_detail.vue?vue&type=script&lang=js&"
import style0 from "./platform_user_detail.vue?vue&type=style&index=0&id=0c2b1a04&prod&lang=less&scoped=true&"
import style1 from "./platform_user_detail.vue?vue&type=style&index=1&id=0c2b1a04&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2b1a04",
  null
  
)

export default component.exports